var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cp-opinion-input',{staticStyle:{"margin-bottom":"10px"},attrs:{"current-user":_vm.currentUser,"send":_vm.sendOpinion,"name":_vm.name,"placeholder-status-post":_vm.placeholderStatusPost,"modalFeed":_vm.modalFeed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }